import Vue from "vue"
const { detect } = require("detect-browser")

Vue.use({
  install: function(Vue) {
    Vue.prototype.$browser = detect()
  },
})
